module.exports = __webpack_public_path__ + "img/toolbar_qk.0358d189.png";